var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor",
    className: "bi bi-hdd",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1.5 1a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M11 11.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m-1 0a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 4.5h10a3 3 0 0 1 3 3V14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7.5a3 3 0 0 1 3-3m0 1a2 2 0 0 0-2 2V14a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7.5a2 2 0 0 0-2-2zM2.5 3a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1zm2-2a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdd);
export default __webpack_public_path__ + "static/media/hdd.1d8a80acd08d42bcfe627ca943db6e3c.svg";
export { ForwardRef as ReactComponent };